import React, { FunctionComponent } from 'react'

import { Grid } from '@material-ui/core'

import { IContatoProps } from './ContatoProps.types'
import { Title, Value } from './styles'

const Contato: FunctionComponent<IContatoProps> = ({
  contato,
  telefone,
  cargo,
}) => {
  return (
    <Grid container justifyContent="space-between">
      <Grid item md={4}>
        <Grid container>
          <Title>Contato</Title>
          <Grid container>
            <Grid>
              <Value>{contato}</Value>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid item md={4}>
        <Grid container>
          <Title>Telefone</Title>
          <Grid container>
            <Grid>
              <Value>{telefone}</Value>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid item md={4}>
        <Grid container>
          <Title>Cargo</Title>
          <Grid container>
            <Grid>
              <Value>{cargo}</Value>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default Contato
